import { render, staticRenderFns } from "./InstitutionGalleryCard.vue?vue&type=template&id=3bb23953&scoped=true&"
import script from "./InstitutionGalleryCard.vue?vue&type=script&lang=js&"
export * from "./InstitutionGalleryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb23953",
  null
  
)

export default component.exports